export default __webpack_public_path__ + "static/scroll-03-ff7fb111b2bce3479c1068891fbf6e47.jpg";